export const card = {
  borderRadius: 16,
  boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  maxWidth: 380,
  margin: '0 auto'
};
export const cardBodyStyle = { padding: '36px 32px 28px' };
export const space = { width: '100%', textAlign: 'center', marginBottom: 24 };
export const cardTitle = { margin: 0, fontWeight: 700 };
export const divider = { marginTop: '5px', marginBottom: '15px' };
export const infoText = { fontSize: 13, fontWeight: 'bold', color: '#9C9C9C' };
export const imageRow = { marginBottom: 10, marginTop: 40 };
